<script lang="ts">
  import type { Translate } from "../i18n";

  const {
    t,
    onResume,
    onRestart,
  }: { t: Translate; onResume: () => void; onRestart: () => void } = $props();
</script>

<section class="overlay" aria-label={t("pause.title")}>
  <div class="dialog">
    <h2>{t("pause.title")}</h2>
    <p>The sky (and your endurance) is the limit.</p>
    <div class="dialog__actions">
      <button type="button" onclick={onResume}>{t("pause.resume")}</button>
      <button type="button" onclick={onRestart}>{t("pause.restart")}</button>
    </div>
  </div>
</section>

<style>
  .dialog__actions {
    display: flex;
    gap: 0.6rem;
  }
</style>
